var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGraphsDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 480.252 480.252",
    style: {
      enableBackground: "new 0 0 480.252 480.252"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -26.749,
    y1: 560.307,
    x2: -26.749,
    y2: 618.071,
    gradientTransform: "matrix(8 0 0 -8 454.1181 4943.2681)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#006DF0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00E7F0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M456.126,464.252v-296c0-4.418-3.582-8-8-8h-80c-4.418,0-8,3.582-8,8v296h-16v-184 c0-4.418-3.582-8-8-8h-80c-4.418,0-8,3.582-8,8v184h-16v-264c0-4.418-3.582-8-8-8h-80c-4.418,0-8,3.582-8,8v264h-16v-152 c0-4.418-3.582-8-8-8h-80c-4.418,0-8,3.582-8,8v152h-24v16h480v-16H456.126z M40.126,464.252v-144h64v144H40.126z M152.126,464.252 v-256h64v256H152.126z M264.126,464.252v-176h64v176H264.126z M376.126,464.252v-288h64v288H376.126z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: -26.7342,
    y1: 560.307,
    x2: -26.7342,
    y2: 618.071,
    gradientTransform: "matrix(8 0 0 -8 454.1181 4943.2681)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#006DF0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00E7F0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_2_)"
    },
    d: "M72.126,224.252c22.091-0.001,39.999-17.91,39.998-40.002c0-7.842-2.306-15.512-6.63-22.054 l56.624-56.632c6.49,4.343,14.119,6.67,21.928,6.688c2.355,0.001,4.705-0.205,7.024-0.616c7.611-1.334,14.667-4.86,20.304-10.144 l47.464,36.488c-7.922,20.622,2.373,43.762,22.995,51.684c20.622,7.922,43.762-2.373,51.684-22.995 c4.646-12.094,3.147-25.689-4.023-36.481l56.608-56.608c18.477,12.23,43.37,7.165,55.599-11.312s7.165-43.37-11.312-55.599 s-43.37-7.165-55.599,11.312c-8.886,13.425-8.886,30.862,0,44.287l-56.608,56.608c-15.855-10.48-36.895-8.356-50.336,5.08 c-0.152,0.152-0.24,0.328-0.384,0.472l-46.776-35.952c8.985-20.182-0.092-43.826-20.274-52.811s-43.826,0.092-52.811,20.274 c-5.557,12.483-4.358,26.94,3.181,38.336l-56.6,56.608c-18.429-12.183-43.244-7.119-55.426,11.31s-7.119,43.244,11.31,55.426 C56.609,221.946,64.281,224.252,72.126,224.252L72.126,224.252z M408.126,16.252c13.255,0,24,10.745,24,24s-10.745,24-24,24 s-24-10.745-24-24S394.871,16.252,408.126,16.252z M296.126,128.252c13.255-0.002,24.001,10.742,24.003,23.997 c0.001,6.369-2.53,12.477-7.035,16.979c-9.5,9.055-24.436,9.055-33.936,0c-9.376-9.37-9.38-24.566-0.011-33.941 C283.649,130.782,289.757,128.251,296.126,128.252L296.126,128.252z M164.47,58.484c3.638-5.226,9.214-8.781,15.488-9.872 c1.393-0.239,2.803-0.359,4.216-0.36c4.911,0.005,9.701,1.522,13.72,4.344c10.857,7.604,13.494,22.569,5.891,33.426 s-22.569,13.494-33.426,5.891c-10.857-7.604-13.494-22.569-5.891-33.426C164.469,58.486,164.469,58.485,164.47,58.484L164.47,58.484 z M55.158,167.276c9.376-9.371,24.573-9.368,33.944,0.008s9.368,24.573-0.008,33.944c-9.5,9.055-24.436,9.055-33.936,0 c-9.376-9.37-9.38-24.566-0.011-33.941C55.151,167.283,55.154,167.28,55.158,167.276z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphsDark);
export default __webpack_public_path__ + "static/media/GraphsDark.252cb94a.svg";
export { ForwardRef as ReactComponent };